import { Modals, ModalsInitialState, ReduxAction } from "../models";
import { ModalsType } from "../types";

export const ModalsState = (state: Modals = ModalsInitialState, action?: ReduxAction): Modals => {
    if (!action) return state;

    switch (action.type) {
        case ModalsType.SHOW_LOGIN_MODAL:
            return { ...state, login: true };
        case ModalsType.HIDE_LOGIN_MODAL:
            return { ...state, login: false };

        case ModalsType.SHOW_LOGOUT_MODAL:
            return { ...state, logout: true };
        case ModalsType.HIDE_LOGOUT_MODAL:
            return { ...state, logout: false };

        case ModalsType.SHOW_PROFILE_MODAL:
            return { ...state, profile: true };
        case ModalsType.HIDE_PROFILE_MODAL:
            return { ...state, profile: false };

        case ModalsType.SHOW_PACKAGES_MODAL:
            return { ...state, packages: true };
        case ModalsType.HIDE_PACKAGES_MODAL:
            return { ...state, packages: false };

        case ModalsType.SHOW_REPORT_MODAL:
            return { ...state, report: true };
        case ModalsType.HIDE_REPORT_MODAL:
            return { ...state, report: false };

        case ModalsType.SHOW_SHARE_MODAL:
            return { ...state, share: true };
        case ModalsType.HIDE_SHARE_MODAL:
            return { ...state, share: false };

        case ModalsType.SHOW_GIFT_MODAL:
            return { ...state, gift: true };
        case ModalsType.HIDE_GIFT_MODAL:
            return { ...state, gift: false };

        case ModalsType.SHOW_DEVICE_ACCESS_MODAL:
            return { ...state, deviceAccess: true };
        case ModalsType.HIDE_DEVICE_ACCESS_MODAL:
            return { ...state, deviceAccess: false };

        case ModalsType.SHOW_MESSAGE_MODAL:
            return { ...state, message: true };
        case ModalsType.HIDE_MESSAGE_MODAL:
            return { ...state, message: false };

        case ModalsType.SHOW_FAVORITE_MODAL:
            return { ...state, favorites: true };
        case ModalsType.HIDE_FAVORITE_MODAL:
            return { ...state, favorites: false };

        case ModalsType.SHOW_FAVORITE_NO_SPORT_MODAL:
            return { ...state, favoritesNoSport: true };
        case ModalsType.HIDE_FAVORITE_NO_SPORT_MODAL:
            return { ...state, favoritesNoSport: false };

        case ModalsType.SHOW_LOGIN_PERMISSION_MODAL:
            return { ...state, loginPermission: true, from: action.payload };
        case ModalsType.HIDE_LOGIN_PERMISSION_MODAL:
            return { ...state, loginPermission: false };

        case ModalsType.SHOW_COMPLETE_PROFILE_MODAL:
            return { ...state, completeProfile: true };
        case ModalsType.HIDE_COMPLETE_PROFILE_MODAL:
            return { ...state, completeProfile: false };

        case ModalsType.SHOW_PROFILE_COMPLETED_MESSAGE_MODAL:
            return { ...state, profileCompletedMessage: true };
        case ModalsType.HIDE_PROFILE_COMPLETED_MESSAGE_MODAL:
            return { ...state, profileCompletedMessage: false };
    }

    return state;
};
